import Text from '@zenbusiness/common-components/Text';
import Title from '@zenbusiness/common-components/Title';
import PropTypes from 'prop-types';

import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import Skeleton from '../Skeleton';
import Row from './Row';

import useStyles from './useStyles';

const HistoryListing = ({ list, ifEmptyName, loading }) => {
  const classes = useStyles();

  if (loading) {
    // eslint-disable-next-line no-param-reassign
    list = Array(4).fill({});
  }

  return (
    <Paper className={classes.card}>
      <Grid container>
        {!loading ? (
          <Title level={3} variant="sm" className={classes.cardTitle}>History</Title>
        ) : (
          <Skeleton width="50%" height="40px" />
        )}
      </Grid>
      <Divider />
      <div className={classes.listingContainer}>
        {list.length > 0 ? list.map((event, index) => (
          <Row
            // index will be used just on loading
            key={event.orderTaskUuid || index}
            loading={loading}
            orderTask={event}
          />
        )) : (
          <Text size="lg" bold align="center">{`No ${ifEmptyName} placed.`}</Text>
        )}
      </div>
    </Paper>
  );
};

export default HistoryListing;

HistoryListing.propTypes = {
  list: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  ifEmptyName: PropTypes.string.isRequired,
  loading: PropTypes.bool
};
